import { render, staticRenderFns } from "./HotelUnassignedRoom.vue?vue&type=template&id=53d22366&scoped=true&"
import script from "./HotelUnassignedRoom.vue?vue&type=script&lang=js&"
export * from "./HotelUnassignedRoom.vue?vue&type=script&lang=js&"
import style0 from "./HotelUnassignedRoom.vue?vue&type=style&index=0&id=53d22366&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d22366",
  null
  
)

export default component.exports